"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FaStar } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import InputField from "../ui/InputField";
import TextareaField from "../ui/TextareaField";
import Button from "../ui/buttons";
export default function NewsPaperfeedbackForm() {
  const $ = _c(15);
  const [rating, setRating] = useState(4);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-18-tamil-600 text-4D4D4D text-center">Help us improve!</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><div className="relative pb-4">{t0}<button onClick={_temp} className="absolute right-0 top-0 text-808080-600 hover:text-000000 transition-all duration-200 transform hover:scale-110 cursor-pointer" aria-label="Close"><RxCross2 size={22} /></button></div><div className="-mx-5 border-b border-DCDCDC" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-16-tamil-400">How would you like to rate your experience?</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [1, 2, 3, 4, 5];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== rating) {
    t4 = <div className="flex gap-2">{t3.map(star => <FaStar key={star} size={24} onClick={() => setRating(star)} className={`cursor-pointer ${star <= rating ? "text-FFDB59 " : "text-bg-909090 opacity-10"}`} />)}</div>;
    $[4] = rating;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== email) {
    t5 = <InputField placeholder="Email Id" value={email} onChange={setEmail} height="48px" />;
    $[6] = email;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== message) {
    t6 = <div className="lg:flex-grow"><TextareaField placeholder="Write your message here" value={message} onChange={setMessage} height="108px" className="lg:h-full" /></div>;
    $[8] = message;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button variant="primary" onClick={_temp2} className=" mt-5 w-full text-18-tamil-700 cursor-pointer">Send Feedback</Button>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t8 = <div className="bg-F8F8F8 mx-auto p-6 w-full max-w-md lg:w-[537px] lg:h-[466px]"><div className="flex flex-col gap-6 h-full">{t1}<div className="flex flex-col gap-4">{t2}{t4}{t5}{t6}{t7}</div></div></div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp2() {}
function _temp() {
  return window.history.back();
}